// Messages domain slice: the rendered message list + its derived heads and the
// history load/cleared flags.
//
// `messages`/`historyLoading` and the memoized `last*Message` originate inside
// useMessageHistory, which publishes them into this slice directly (WS-10.1 — no
// provider effect-bridge). `historyCleared` was a provider-owned useState (toggled
// on MAA_RESET and on ask); it lives here and is driven through setHistoryCleared,
// exactly like the composer flags.
export const messagesSlice = (set) => ({
  messages: [],
  lastBotMessage: undefined,
  lastUserMessage: undefined,
  historyLoading: false,
  historyCleared: false,
  setMessages: (value) => set({ messages: value }),
  setLastBotMessage: (value) => set({ lastBotMessage: value }),
  setLastUserMessage: (value) => set({ lastUserMessage: value }),
  setHistoryLoading: (value) => set({ historyLoading: value }),
  setHistoryCleared: (value) => set({ historyCleared: value }),
});
